import type { EventPageTabEntities, RacePageTabEntities } from '..';

export const getIsRaceBasedEntity = (
  entities: EventPageTabEntities | RacePageTabEntities
): entities is RacePageTabEntities => 'raceId' in entities;
